<template>
  <Modal
    title="Convert to Invoice"
    modal-classes="modal-xl"
    save-button-text="Create Invoice"
    @close="() => emit('close')"
    @save="convertToInvoice"
  >
    <form @submit.prevent="convertToInvoice">
      <div class="mb-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <th>Unit Cost</th>
              <th>Total Cost</th>
              <th>Total Invoiced</th>
              <th>Amount to Invoice</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedItems"
              :key="index"
              style="vertical-align: middle"
            >
              <td>{{ item.description }}</td>
              <td>
                <NumberInput
                  v-model="item.quantity"
                  name="quantity"
                  :step="1"
                  readonly
                  :is-minor-value="false"
                />
              </td>
              <td>
                <NumberInput
                  v-model="item.price"
                  name="price"
                  :step="0.01"
                  readonly
                  :is-price-value="true"
                />
              </td>
              <td>
                <NumberInput
                  v-model="item.total"
                  name="total"
                  :step="0.01"
                  readonly
                  :is-price-value="true"
                  :is-minor-value="false"
                />
              </td>
              <td>
                <NumberInput
                  v-model="item.amount_invoiced"
                  name="amount_invoiced"
                  :step="0.01"
                  readonly
                  :is-price-value="true"
                  :is-minor-value="false"
                />
              </td>
              <td>
                <NumberInput
                  v-model="item.amount_to_invoice"
                  name="amount_to_invoice"
                  :step="0.01"
                  required
                  :is-price-value="true"
                  :error="item.error"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </Modal>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import NumberInput from "@/components/form/numberInput.vue";
import Modal from "@/components/modal.vue";

const props = defineProps({
  customer: {
    type: Object,
    default: () => ({
      id: null,
      name: null,
    }),
  },
  selectedItems: {
    type: Object,
  },
});

onMounted(() => {
  selectedItems.value.forEach((item) => {
    if (!item.amount_to_invoice) {
      item.amount_to_invoice = calculateRemainingAmount(item);
    }
    item.error = false;
  });
});

const selectedItems = ref(props.selectedItems);

watch(
  selectedItems,
  (newItems) => {
    newItems.forEach((item) => {
      item.error = false;
    });
  },
  { deep: true }
);

function convertToInvoice() {
  const itemsToInvoice = selectedItems.value.map((item) => {
    return {
      ...item,
      amount_to_invoice: item.amount_to_invoice,
    };
  });

  emit("convertToInvoice", itemsToInvoice);
}
function calculateRemainingAmount(item) {
  return parseFloat(item.total / 100) - parseFloat(item.amount_invoiced / 100);
}

const emit = defineEmits(["close", "convertToInvoice"]);
</script>
